import React from 'react';
import { FaInstagram, FaYoutube, FaTelegram } from 'react-icons/fa6';

const BaleIcon = (props) => (
  <img src="https://bale.ai/uploads/bale.png" alt="Bale" {...props} />
);

const RubikaIcon = (props) => (
  <img
    src="https://web.rubika.ir/assets/icons/icon-192x192.png"
    alt="Rubika"
    {...props}
  />
);

const AparatIcon = (props) => (
  <img
    src="/images/aparat--icon--color-black@256px.png"
    alt="Aparat"
    {...props}
  />
);

const aboutLinks = [
  { label: 'پیگیری پیام', href: '/followup' },
  { label: 'درباره خجالتی‌ام', href: '/about-us' },
  // TODO: enable this when product is ready for crowd-expression and terms and faq
  // { label: 'بیاد ماکان نصیری', href: '/crowd-expression/makan' },
  // { label: 'قوانین و مقررات', href: '/terms' },
  // { label: 'سوالات متداول', href: '/faq' },
];

const supportContacts = [
  {
    label: 'پشتیبانی تلگرام',
    href: 'https://t.me/khejalatiam_admin',
    icon: FaTelegram,
    iconColor: 'text-[#0088cc]',
  },
  {
    label: 'پشتیبانی بله',
    href: 'https://ble.ir/Admin_Khejalatiam',
    icon: BaleIcon,
    iconColor: '',
  },
];

const socialChannels = [
  {
    label: 'Instagram',
    href: 'https://instagram.com/khejalatiam',
    icon: FaInstagram,
    iconColor: 'text-[#E4405F]',
  },
  {
    label: 'Aparat',
    href: 'https://www.aparat.com/khejalatiam',
    icon: AparatIcon,
    iconColor: '',
  },
  // {
  //   label: 'Youtube',
  //   href: 'https://youtube.com/@khejalatiam',
  //   icon: FaYoutube,
  //   iconColor: 'text-[#FF0000]',
  // },
  // {
  //   label: 'Rubika',
  //   href: 'https://rubika.ir/khejalatiam',
  //   icon: RubikaIcon,
  //   iconColor: '',
  // },
];

const PublicFooter = () => {
  return (
    <footer
      className="mt-16 border-t border-purple-100 bg-white/70 backdrop-blur-md"
      dir="rtl"
    >
      <div className="container mx-auto max-w-6xl px-4 py-10">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div className="space-y-5">
            <div>
              <h3 className="mb-3 text-lg font-bold text-gray-800">
                درباره ما
              </h3>
              <p className="max-w-md text-sm leading-7 text-gray-600">
                خجالتی‌ام یک سرویس ساده و امن برای ارسال پیام‌های ناشناس با
                قالب‌های آماده است.
              </p>
            </div>

            <div>
              <h4 className="mb-3 text-sm font-semibold text-gray-800">
                لینک‌های مهم
              </h4>
              <ul className="grid gap-2 text-sm text-gray-600 sm:grid-cols-2">
                {aboutLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="inline-flex items-center gap-2 rounded-lg px-2 py-1 transition-colors hover:bg-purple-50 hover:text-purple-700"
                    >
                      <span className="h-1.5 w-1.5 rounded-full bg-purple-400" />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="space-y-5">
            <h3 className="text-lg font-bold text-gray-800">تماس با ما</h3>
            <ul className="space-y-3 text-sm text-gray-600">
              {supportContacts.map((support) => {
                const Icon = support.icon;
                const iconCls = support.iconColor || 'text-purple-600';

                return (
                  <li
                    key={support.href}
                    className="rounded-xl border border-gray-100 bg-white px-4 py-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
                  >
                    <span className="block text-xs text-gray-400"></span>
                    <a
                      href={support.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-1 inline-flex items-center gap-2 font-medium text-gray-700 transition-colors hover:text-purple-700"
                    >
                      <Icon className={`h-4 w-4 ${iconCls}`} />
                      <span>{support.label}</span>
                    </a>
                  </li>
                );
              })}
              <li className="rounded-xl border border-gray-100 bg-white px-4 py-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md">
                <span className="block text-xs text-gray-400">ایمیل</span>
                <a
                  href="mailto:info@khejalatiam.ir"
                  className="mt-1 block font-medium text-gray-700 transition-colors hover:text-purple-700"
                >
                  info@khejalatiam.ir
                </a>
              </li>
            </ul>
          </div>

          <div className="space-y-5">
            <h3 className="text-lg font-bold text-gray-800">
              شبکه‌های اجتماعی
            </h3>
            <div className="flex flex-wrap gap-3">
              {socialChannels.map((social) => {
                const Icon = social.icon;
                const iconCls = social.iconColor || 'text-purple-600';

                return (
                  <a
                    key={social.href}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 rounded-2xl border border-purple-100 bg-white px-4 py-3 text-sm text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-purple-200 hover:shadow-md"
                    aria-label={social.label}
                    title={social.label}
                  >
                    <Icon className={`h-5 w-5 ${iconCls}`} />
                  </a>
                );
              })}
            </div>

            <div>
              <h3 className="mb-3 text-lg font-bold text-gray-800">
                نماد اعتماد
              </h3>
              <a
                referrerPolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=720397&Code=DLRsa0H2O7tg2yR3vEs4qDus6nbSxFaF"
                className="inline-flex items-center rounded-2xl border border-purple-100 bg-white p-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
              >
                <img
                  id="DLRsa0H2O7tg2yR3vEs4qDus6nbSxFaF"
                  referrerPolicy="origin"
                  src="https://Trustseal.eNamad.ir/logo.aspx?id=720397&Code=DLRsa0H2O7tg2yR3vEs4qDus6nbSxFaF"
                  alt="نماد اعتماد الکترونیکی"
                  className="h-24 w-auto max-w-full object-contain"
                  style={{ cursor: 'pointer' }}
                  code="DLRsa0H2O7tg2yR3vEs4qDus6nbSxFaF"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-gray-100 pt-4 text-center text-xs text-gray-500">
          © ۱۴۰۵ خجالتی‌ام. تمامی حقوق محفوظ است.
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
